module.exports = "\r\n<footer class=\"app-footer\">\r\n  <a href=\"\">Social Net</a> &copy; {{year}}.\r\n  <span class=\"float-right\">Powered by <a href=\"https://socialnet.vnpt.vn\"><img src=\"/assets/img/logo/logo_socialnet.svg\" style=\"height: 20px;\"></a></span>\r\n</footer>\r\n"


//////////////////
// WEBPACK FOOTER
// D:/Project/Nodejs/SocialListening_Cloud/frontend_cloud/src/app/components/app-footer/app-footer.component.html
// module id = ../../../../../src/app/components/app-footer/app-footer.component.html
// module chunks = main